import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Typography,
} from '@mui/material';

const MaintenanceGate = ({ children }) => {
  const [status, setStatus] = React.useState('checking');
  const HEALTH_CHECK_INTERVAL_MS = 5 * 60 * 1000;

  const checkHealth = React.useCallback(async () => {
    const baseUrl = `${process.env.GATSBY_API_URL || ''}`.replace(/\/$/, '');
    if (!baseUrl) {
      setStatus('maintenance');
      return;
    }

    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), 5000);

    try {
      const response = await fetch(`${baseUrl}/health`, {
        method: 'GET',
        signal: controller.signal,
      });

      if (!response.ok) {
        setStatus('maintenance');
        return;
      }

      const data = await response.json().catch(() => null);
      if (data?.status === 'Healthy' && data?.db === 'Healthy') {
        setStatus('ready');
        return;
      }

      setStatus('maintenance');
    } catch (error) {
      setStatus('maintenance');
    } finally {
      window.clearTimeout(timeoutId);
    }
  }, []);

  React.useEffect(() => {
    checkHealth();
    const intervalId = window.setInterval(
      checkHealth,
      HEALTH_CHECK_INTERVAL_MS
    );
    return () => window.clearInterval(intervalId);
  }, [checkHealth, HEALTH_CHECK_INTERVAL_MS]);

  if (status === 'checking') {
    return (
      <Container
        maxWidth="sm"
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Container>
    );
  }

  if (status === 'ready') {
    return children;
  }

  const handleRefresh = () => window.location.reload();

  return (
    <Container
      maxWidth="sm"
      sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}
    >
      <Box sx={{ textAlign: 'center', width: '100%', py: 8 }}>
        <Typography variant="h3" component="h1" sx={{ fontWeight: 700, mb: 2 }}>
          Under Maintenance
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 1 }}>
          Pintuna is temporarily unavailable while we complete scheduled
          maintenance. Please come back shortly.
        </Typography>
        <Button variant="contained" onClick={handleRefresh}>
          Refresh
        </Button>
      </Box>
    </Container>
  );
};

export default MaintenanceGate;
